export default {
    title: "O-I",
    support: "Támogatás",
    dashboard: "Műszerfal"
}